@if (isLoginURL) {
  <app-header></app-header>
}
<section class="" [ngClass]="{'wrapper': isLoginURL}">
  @if (isLoginURL) {
    <app-leftnavmenu></app-leftnavmenu>
  }
  <router-outlet></router-outlet>
</section>
@if (isLoginURL) {
  <app-footer></app-footer>
}
<!-- <ngx-spinner *ngIf="!isLoginURL" bdColor="rgba(0,0,0,0)" size="large" color="#fff" type="ball-clip-rotate" [fullScreen]="true">
<p style="color: white"> Loading... </p>
</ngx-spinner> -->
@if (isLoginURL) {
  <ngx-spinner bdColor="rgba(0,0,0,0.6)" size="large" color="#fff" type="ball-clip-rotate" [fullScreen]="true">
    <!-- <p style="color: white"> Loading... </p> -->
  </ngx-spinner>
}
